<template>
  <button
    class="bg-emerald-600 px-4 py-2 rounded-xl text-white font-semibold block mb-4"
  >
    <slot></slot>
  </button>
</template>
